import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITCYStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTCYStakingConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_tcy_stats', timeframe)) as ITCYStats[]
	const series1 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.DEPOSIT_AMOUNT }
	})
	const series2 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.WITHDRAW_AMOUNT }
	})
	const series3 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.STAKING_CHANGE_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'tcy deposits',
			type: 'bars',
			seriesGroup: '[TCY]',
			color: 'green',
			unitSymbol: ''
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'tcy withdrawals',
			type: 'bars',
			seriesGroup: '[TCY]',
			color: 'red',
			unitSymbol: ''
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'staking change cumulative',
			type: 'line',
			seriesGroup: ' [TCY]',
			color: 'orange',
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TCYStaking = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTCYStakingConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="TCY Staking"
			chartDesc="Amount of TCY currently staked."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default TCYStaking
